import { Tabs, TabsProps } from "antd"
import BannerBg from "../../../components/bg/BannerBg"
import {  TYPE_MESSAGES, TYPE_NOTIFICATIONS, USER_TYPE_ORGANIZATION } from "../../../constants/constants";
import { useEffect, useMemo, useState } from "react";
import { getAllOrgBrands } from "../../../API/endpoints/Brands";
import TasksSection from "../components/TasksSection";
import DashboardMessages from "./components/DashboardMessages";
import DashboardNotifications from "./components/DashboardNotifications";
import DiscoveryRequestsList from "./components/DiscoveryRequestsList";
import DashboardCounts from "./components/DashboardCounts";

interface Props {
    userProfile: any
}
const Dashboard = (props: Props) => {
    const { userProfile } = props;


    const [brands, setBrands] = useState<any>([]);

    useEffect(() => {
        if (userProfile?.user_type === USER_TYPE_ORGANIZATION) {
            getAllOrgBrands(userProfile?.org_id).then((res: any) => {
                setBrands(res?.data?.rows || []);
            }).catch((err) => {
                console.log('err', err);

            })

        }

    }, [userProfile]);


    const messagesTabs: TabsProps['items'] = useMemo(() => [
        {
            key: TYPE_MESSAGES,
            label: 'Messages',
            children: <DashboardMessages userProfile={userProfile} />,
        },
        {
            key: TYPE_NOTIFICATIONS,
            label: 'Notifications',
            children: <DashboardNotifications userProfile={userProfile} />,
        },
    ], [userProfile]);


    return (
        <div className="grid grid-cols-4 gap-x-[16px] p-[16px]">
            <div className="col-span-3 flex flex-col gap-y-[16px] h-[calc(100vh-81px)] overflow-auto overflow-scroll-bar pr-1">
                <div className="flex gap-x-[16px] h-[300px]">
                    <div className="relative w-[250px] h-full bg-gradient-to-tr from-[#B2DDFF] via-[#ecf5fd] to-white rounded-[8px] min-h-[300px]">
                        <div className="z-10 absolute top-0 l-0 px-[16px] py-[40px]">
                            <p className="text-[20px] font-medium capitalize">Hi, {userProfile?.first_name} {userProfile?.last_name}</p>
                            <p className="text-[13px] text-[#475467]">Welcome to <br /> <strong>Asia Trade Management!</strong><br /> <br />Simplify your trade operations with us. Let’s take your business to the next level together.</p>
                        </div>
                        <BannerBg className="absolute right-0 bottom-0  rounded-[8px]" />
                    </div>
                    <TasksSection brands={brands} userProfile={userProfile} />
                </div>
                <div className="flex-1 bg-white rounded-[8px] p-[16px] pb-0 flex-1">
                    <div className="h-[calc(100vh-98px)] overflow-auto overflow-scroll-bar">
                        <p className="text-[14px] font-medium mb-[16px]">Open Discovery Requests</p>
                        {/* <Select
                            className="min-w-[120px]"
                            size="small"
                            variant="borderless"
                            options={brands}
                        /> */}
                        <DiscoveryRequestsList userProfile={userProfile} />
                    </div>
                    {/* <div className="flex flex-col gap-y-[16px] mt-[12px] h-[calc(100vh-49px)] overflow-auto">
                        <div className="h-full w-full flex flex-col gap-y-[12px] items-center justify-center">
                            <LockedIcon />
                            <p className="font-medium text-[14px] m-0">Locked</p>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="flex flex-col gap-y-[16px] h-[calc(100vh-81px)]">
                <DashboardCounts userProfile={userProfile}/>
                <div className="col-span-2 rounded-[8px] bg-white px-[16px] py-[8px] flex-1">
                    <Tabs defaultActiveKey="1" items={messagesTabs} destroyInactiveTabPane />
                </div>
            </div>
        </div>
    )
}

export default Dashboard